/* eslint-disable */
const pre = '/drp/'
//
export default {
  path: '/drp',
  title: '进销存',
  header: 'home',
  custom: 'i-icon-demo i-icon-demo-list',
  children: [
    {
      path: `${pre}supplier`,
      title: '供应商审核',
    },
    {
      path: `${pre}drp1`,
      title: '采购商品',
    },
    {
      path: `${pre}drp5`,
      title: '采购管理',
    },
    // {
    //   path: `${pre}product`,
    //   title: '产品管理',
    // },
    {
      path: `${pre}drp2`,
      title: '采购明细',
    },
    {
      path: `${pre}drp3`,
      title: '采购退货',
    },
    {
      path: `${pre}drp4`,
      title: '采购退货明细',
    },
    {
      path: `${pre}stock`,
      title: '库存管理',
    },
  ],
}
